export default "__VITE_ASSET__akSLc0wa__"